import { useState, useRef, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useLocation } from "react-router-dom";
import "./ValidadorDeProductos.css";

const ValidadorDeProductos = () => {
  const [CodigoVerificacion, SetCodigoVerificacion] = useState("");
  const [Base64, SetBase64] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const location = useLocation();

  useEffect(() => {
    SetCodigoVerificacion(location.state.guid);
  }, [location.state.guid]);

  const showErrorAlert = (message) => {
    const alertDiv = document.createElement("div");
    alertDiv.classList.add("alert-error");
    alertDiv.textContent = message;

    document.body.appendChild(alertDiv);

    setTimeout(() => {
      alertDiv.remove();
    }, 3000);
  };

  const onFormSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);

    fetch(`${process.env.REACT_APP_API_ROOT_SECURITY}GetToken`, {
      method: "POST",
    })
      .then(async (response) => {
        const tokenTemp = await response.json();

        fetch(
          `${process.env.REACT_APP_API_ROOT_HEADER}GetStorageTypeAndStorageReferenceByGuid/${CodigoVerificacion}`
        )
          .then(async (response) => {
            const header = await response.json();

            fetch(
              `${process.env.REACT_APP_API_ROOT_BLOB}GetBlobFile?blobName=${header.storageReference}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${tokenTemp}`,
                },
              }
            )
              .then(async (response) => {
                const result = await response.json();
                if (result.isSuccess) {
                  SetBase64(result.data.content);
                } else {
                  throw new Error("El resultado no fue exitoso");
                }
              })
              .catch((error) => {
                setLoading(false);
                showErrorAlert(`Error al obtener el archivo: ${error.message}`);
              });
          })
          .catch((error) => {
            setLoading(false);
            showErrorAlert(`Error al obtener el encabezado: ${error.message}`);
          });
      })
      .catch((error) => {
        setLoading(false);
        showErrorAlert(`Error al obtener el token: ${error.message}`);
      });

    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  return (
    <div>
      {Base64 === null && (
        <div
          className="centered"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          <div className="ui card cardWidth">
            <div style={{ marginLeft: "40px" }}>
              <img
                alt="Logo"
                src="https://ri.gob.do/wp-content/uploads/2018/09/RI-Horizontal500x143.png"
                width={300}
              />
            </div>
            <div className="content">
              <form
                className="ui form"
                onSubmit={onFormSubmit}
                style={{ marginTop: "10px" }}
              >
                <div className="field">
                  <label style={{ textAlign: "center" }}>
                    Código de verificación <span className="required">(*)</span>
                  </label>
                  <input
                    type="text"
                    disabled
                    value={CodigoVerificacion}
                    name="first-name"
                    style={{ marginTop: "10px", textAlign: "center" }}
                  />
                </div>

                <button
                  className="btnValidar"
                  title="Validar código"
                  type="submit"
                  style={{ marginTop: "40px" }}
                >
                  {loading ? (
                    <div className="loader"></div>
                  ) : (
                    "Validar"
                  )}
                </button>
              </form>
              {error && (
                <div className="alert-error">
                  <strong>Error: </strong>
                  {error}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {Base64 !== null && (
        <iframe
          style={{ height: "100vh", width: "100vw" }}
          src={"data:application/pdf;base64," + Base64}
          title="Files"
        ></iframe>
      )}
    </div>
  );
};

export default ValidadorDeProductos;
